import { Model } from '@shared-features/models/model';
import { DashboardTypes } from '@shared/enums/dashboard-types.enum';
import { Expose } from 'class-transformer';

export class UserDashboard extends Model {
  @Expose() url: string;
  @Expose() name: string;
  @Expose() type: DashboardTypes;
  @Expose() token: string;
}
